import React from 'react';
import PropTypes from 'prop-types';
import {NavLink} from 'react-router-dom';

import {Link} from '@spothero/ui';

import SubMenu from './SubMenu';

const MobileNavigationItem = ({
    children,
    handleNavigationMenuToggle,
    handleSubMenuToggle,
    handleSubMenuCloseClick,
    handleMenuItemClick,
    isSubMenuOpen,
    label,
    route,
}) => {
    return children ? (
        <SubMenu
            label={label}
            onClick={handleSubMenuToggle(label)}
            menuContentArray={children}
            isOpen={isSubMenuOpen(label)}
            onBackButtonClick={handleSubMenuToggle(label)}
            onClose={handleSubMenuCloseClick}
            onMenuItemClick={handleMenuItemClick}
        />
    ) : (
        <Link
            as={NavLink}
            to={route}
            onClick={handleNavigationMenuToggle}
            fontSize="sm"
            color="black"
            paddingY={1}
            paddingX={3}
        >
            {label}
        </Link>
    );
};

MobileNavigationItem.propTypes = {
    children: PropTypes.arrayOf(
        PropTypes.shape({
            heading: PropTypes.string.isRequired,
            submenu: PropTypes.arrayOf(
                PropTypes.shape({
                    label: PropTypes.string.isRequired,
                    subtitle: PropTypes.string,
                    route: PropTypes.string.isRequired,
                    isDisabled: PropTypes.bool,
                })
            ),
        })
    ),
    handleNavigationMenuToggle: PropTypes.func.isRequired,
    handleSubMenuToggle: PropTypes.func.isRequired,
    handleSubMenuCloseClick: PropTypes.func.isRequired,
    handleMenuItemClick: PropTypes.func.isRequired,
    isSubMenuOpen: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    route: PropTypes.string,
};

export default MobileNavigationItem;
